var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCeilingFan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.2,13.2H2.8V2.8h10.4V13.2z M3.3,12.7h9.4V3.3H3.3V12.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.59,9.91c-0.99,0-1.8-0.81-1.8-1.8c0-0.99,0.81-1.8,1.8-1.8s1.8,0.81,1.8,1.8 C11.39,9.1,10.58,9.91,9.59,9.91z M9.59,6.81c-0.72,0-1.3,0.58-1.3,1.3s0.58,1.3,1.3,1.3s1.3-0.58,1.3-1.3S10.31,6.81,9.59,6.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.41,9.91c-0.99,0-1.8-0.81-1.8-1.8c0-0.99,0.81-1.8,1.8-1.8s1.8,0.81,1.8,1.8C8.21,9.1,7.4,9.91,6.41,9.91z  M6.41,6.81c-0.72,0-1.3,0.58-1.3,1.3s0.58,1.3,1.3,1.3s1.3-0.58,1.3-1.3S7.13,6.81,6.41,6.81z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeilingFan);
export default __webpack_public_path__ + "static/media/CeilingFan.dc9961284a6391a1c95c3df17c12949c.svg";
export { ForwardRef as ReactComponent };